import { render } from "./ELECTED_VAL_NEW_V2.vue?vue&type=template&id=1d53b65e"
import script from "./ELECTED_VAL_NEW_V2.vue?vue&type=script&lang=js"
export * from "./ELECTED_VAL_NEW_V2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__